module.exports = __webpack_public_path__ + "static/media/flip-v.0c77f1d0.svg";